import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import REVERT_DROMO_IMPORT from '../mutations/revert-dromo-import.graphql';

type DromoImportRollbackInput = {
    originId: string;
};

export const useRevertDromoImport = (): {
    revertDromoImport: (arg1: DromoImportRollbackInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [revertDromoImport, {loading, error}] = useMutation<
        any,
        {input: DromoImportRollbackInput}
    >(REVERT_DROMO_IMPORT);

    return {
        revertDromoImport: (input: DromoImportRollbackInput) =>
            revertDromoImport({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
